import React from 'react'
import graphql from 'babel-plugin-relay/macro'
import { fetchQuery } from 'config/amber-relay'
import Select from 'components/v2/Select'

export default function TicketTypeSelectMulti(props) {
  const fetch = async where => {
    const { ticketTypes } = await fetchQuery(
      graphql`
        query TicketTypeSelectMultiQuery($where: TicketTypeWhere) {
          ticketTypes(where: $where, orderBy: [code], order: ASC) {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      `,
      { where }
    )

    return ticketTypes.edges.map(({ node }) => ({
      key: node.id,
      value: node.id,
      text: node.name,
    }))
  }

  return (
    <Select
      {...props}

      getByValue={value => {

        if (!value || value.length === 0) {
          return Promise.resolve([]); // Manejar valores vacíos
        }
        return fetch({ id: { in: value } });
      }}
      loadOptions={searchQuery => fetch({ name: { iLike: `${searchQuery}%` } })}
    />
  )
}

TicketTypeSelectMulti.defaultProps = {
  label: 'Tipo de Ticket',
  placeholder: 'Tipo de Ticket',
  loadOnMount: true,
  multiple: false,
}
